var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconDownload = function SvgIconDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00913D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 8.582 8.43) translate(10.707)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.829,
    height: 1.992,
    rx: 0.996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.829.833V16.1c0 .46-.373.833-.833.833-.46 0-.833-.373-.833-.833V.833c0-.46.373-.833.833-.833.46 0 .833.373.833.833z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.829,
    height: 1.992,
    y: 14.941,
    rx: 0.996
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.371 1.245v9.961c0 .55.373.996.833.996.46 0 .833-.446.833-.996v-9.96c0-.551-.373-.997-.833-.997-.46 0-.833.446-.833.996z",
    transform: "rotate(90 8.582 8.43) rotate(-90 7.578 7.078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.766 7.308L5.3 11.533c.325.389.852.389 1.177 0 .325-.39.325-1.02 0-1.409L2.944 5.9c-.325-.39-.852-.39-1.178 0-.325.389-.325 1.02 0 1.408z",
    transform: "rotate(90 8.582 8.43) rotate(-90 7.578 7.078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.462 5.898L5.93 10.125c-.325.389-.325 1.02 0 1.409.326.389.853.389 1.178 0l3.532-4.227c.325-.39.325-1.02 0-1.41-.325-.388-.852-.388-1.178 0v.001z",
    transform: "rotate(90 8.582 8.43) rotate(-90 7.578 7.078)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-download.42cf04e3.svg";
export { ForwardRef as ReactComponent };